import { Product, Format, FormatOption } from './product';

export class BasketPrice{ 
    base_cents : number
    total_cents : number                                // Importe final a pagar, en céntimos de €
    delivery_cost_cents : number                        // Importe preparación y envio , en céntimos de €
    offer_discount_cents : number                       // Importe de los descuentos por oferta, en céntimos de €
    plusi_points : number                               // Puntos que acumularía en la tarjeta de fidelización
    savings_cents : number                              // Importe acumulado de los descuentos aplicados, en céntimos de €
    voucher_discount_cents : any                        // Importe de los vales de fidelización desglosados, en céntimos de €
    tax_cents : number                                  // Importe de impuestos totales, en céntimos de €   
    weight_grams : number                               // Peso estimado de la cesta, en gramos
    PSD2_cents  : number                                // Importe coste articulos peso variable (pds2)
    basketprice_cents: number                           // Importe cesta sin incluir coste PSD2
    basketpricePSD2_cents: number                       // Importe total con conste PSD2 
    voucher_discount : Map <string, number>;

    constructor(values: Object = {}){
        (<any>Object).assign(this, values);       

        this.voucher_discount = new Map<string,number>();
        
        if (this.voucher_discount_cents != null){
            Object.keys (this.voucher_discount_cents).forEach (k => { 
                this.voucher_discount.set(k, this.voucher_discount_cents[k] / 100);
           });
        }
    }

    public get base () : number {
        return this.base_cents / 100;
    }
    public get total () : number {
        return this.total_cents / 100;
    }
    public get delivery () : number {
        return this.delivery_cost_cents / 100;
    }
    public get savings () : number {
        return this.savings_cents / 100;
    }
    public get offer_discount () : number {
        return this.offer_discount_cents / 100;
    }
    public get base_psd2 () : number{
        return this.basketprice_cents / 100;
    }
    public get total_psd2 () : number{
        return this.basketpricePSD2_cents / 100
    }
    public get psd2 () : number {
        return this.PSD2_cents / 100;
    }
    // Eliminat 22/08/2019
    // public get tax () : number {
    //     return this.tax_cents / 100;
    // }

}

export class BasketProduct  {
    basket_position : number                        // Posición del producto dentro de la cesta
    item_id : string                                //  Identificador (código interno Supsa) del producto
    qty_milis: number                               //  Cantidad deseada del producto x1000
    selected_format : any                           //  Diccionario con la selección <format_id,option_id> (véase capítulo 4)
    notes : string                                  // Observaciones añadidas por el usuario, es un texto arbitrario
    flag_action : boolean                           //  No utilizado, siempre devolverá falso
    product : Product                               // Product Instancia con toda la información del producto , Es el mismo modelo de datos que en /api/products/…
    gift : boolean                                  // Producto que viene de regalo con promocion

    selected_options : FormatOption[];
    selected_serviceFormatOption :  FormatOption

    constructor(values: Object = {}){
        this.basket_position = 0;
        this.notes = '';
        this.product = null;
        this.flag_action = false;
        this.selected_format = {};
        this.gift = false;
        
        (<any>Object).assign(this, values);       
        this.product = new Product(this.product);
        
        this.selected_options = [];

        Object.keys (this.selected_format).forEach (k => { 
            // this.selected_formats.set(k, this.selected_format[k]);
            let sf : Format = this.product.getServiceFormat();
            this.selected_serviceFormatOption = this.product.getServiceFormatOption(sf.format_id, this.selected_format[sf.format_id]);
            this.selected_options.push( this.product.getServiceFormatOption(k, this.selected_format[k]));
        });
    }
    
    public get quantity (){
        return this.qty_milis / 1000;
    }

    public set quantity (value : number){
        this.qty_milis = Math.round(value * 1000);
    }

    public get totalPrice () : number{
        let price : number = 0;
        let format : FormatOption;

        // if (this.product.qty_required > 0 ){
        //     price =  (this.quantity - (this.quantity  %  this.product.qty_required))  * this.product.price;
        //     price +=  (this.quantity  %  this.product.qty_required) * this.product.oldPrice;   
        // } else {
        //     price = this.quantity * this.product.price;
        // }

        price = this.quantity * this.product.price;
        
        if (this.product.has_format){
            format = this.getPriceOption();
            if (format) {
                price =  price  * format.percent;
            }
        }
        return price
    }
    
    public get totalOldPrice () : number{
        let price : number = 0;
        let format : FormatOption;

        price =  this.quantity * this.product.oldPrice;
        
        if (this.product.has_format){
            format = this.getPriceOption();
            if (format) {
                price =  price  * format.percent;
            }
        }
        return price
    }

    public getPriceOption() : FormatOption {
        let priceOption : FormatOption;
        
        if (!this.selected_serviceFormatOption){
            return null;
        }
        
        if (this.selected_serviceFormatOption.percent > 0){
            priceOption = this.selected_serviceFormatOption;
        } else {
            priceOption = this.selected_options.find( option => {
                return option.option_id != this.selected_serviceFormatOption.option_id && option.percent > 0;
            });
        }

        return priceOption;
    }

    public getMainFormatText (lang : string, defaultUnitText : string) : string {
        
        return this.selected_serviceFormatOption ? this.selected_serviceFormatOption.getText(lang).toLocaleLowerCase() : defaultUnitText ;
    }

    public getOptionFormatText (lang : string, formatText: string) : string {
        let text : string = '';
        if (this.selected_options.length > 1){
            text = formatText;

            this.selected_options.filter( option => {
                return option.option_id != this.selected_serviceFormatOption.option_id;
            }).forEach(option =>{
                text = text + option.getText(lang).toLocaleLowerCase() + ', ';
            });
        }
        return text;
    }

}

export class PaymentData {
    URL : string
    verb : string
    parameters : PaymentParameters
}

export class PaymentParameters {
    Ds_SignatureVersion : string
    Ds_MerchantParameters : string
    Ds_Signature : string
}

export class Batch {
    batch_id : string
    batch_qty : number
    flag_action : boolean
}